import { supabase } from "./supabase";

function workspaceSlug(name: string) {
  const base =
    name
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "")
      .slice(0, 68) || "workspace";
  const suffix = crypto.randomUUID().replaceAll("-", "").slice(0, 8);
  return `${base}-${suffix}`;
}

export async function createWorkspace(name: string) {
  if (!supabase) {
    throw new Error("Supabase não está configurado.");
  }

  const normalizedName = name.trim().slice(0, 120);
  if (normalizedName.length < 2) {
    throw new Error("Informe um nome de workspace com pelo menos 2 caracteres.");
  }

  const { data, error } = await supabase.rpc("create_workspace", {
    p_name: normalizedName,
    p_slug: workspaceSlug(normalizedName),
  });

  if (error) throw error;
  if (typeof data !== "string" || !data) {
    throw new Error("O backend não retornou o identificador do workspace.");
  }
  return data;
}

export async function ensureInitialWorkspace(preferredName: string) {
  if (!supabase) return null;

  const { data: existing, error: membershipError } = await supabase
    .from("workspace_members")
    .select("workspace_id")
    .limit(1)
    .maybeSingle();

  if (membershipError) throw membershipError;
  if (existing?.workspace_id) return existing.workspace_id as string;

  const name = preferredName.trim().slice(0, 120) || "Meu workspace";
  return createWorkspace(name);
}
